<template>
    <div id="contactFirst">
        <div id="contactMap">
            <!-- <baidu-map class="mapView"
            :center="center" 
            :zoom="zoom" 
            :scroll-wheel-zoom="true"
            @ready="handler">
                <bm-marker :position="{lng: center.lng, lat: center.lat}" animation="BMAP_ANIMATION_DROP">
                    <bm-info-window :show="true">
                        <p>天津三博水科技有限公司</p>
                        <div>(天津科技金融大厦17层)</div>
                    </bm-info-window>
                </bm-marker>
            </baidu-map> -->
            <img src="../../assets/imgs/地址.png" >
        </div>
        <div id="contactText">
            <div>
                <p>地址：天津市南开区梅苑路科技金融大厦17层</p>
                <p>电话：022-58951598</p>
                <p>联系人：尹学锐</p>
                <p>手机：18622595935</p>
                <p>网址：<router-link to="/">www.sambowater.com</router-link></p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            center: {lng: 0, lat: 0},
            zoom: 15
        }
    },
    methods: {
        // handler ({BMap, map}) {
        //     this.center.lng = 117.1340313511
        //     this.center.lat = 39.0998997329
        // }
    }
}
</script>

<style scoped>
    #contactFirst{
        width: 1040px;
        border: 5px solid #e8e8e8;
        margin: 20px  auto;
        margin-top: 30px;
        padding: 35px;
        overflow: hidden;
    }
    #contactMap{
        width: 580px;
        height: 300px;
        float: left;
    }
    .mapView{
        width: 100%;
        height: 100%;
    }
    #contactText{
        line-height: 25px;
        height: 210px;
        display: flex;                               
        align-items:Center;  
        position: relative;
    }  
    #contactText>div{
        position: absolute;
        right: 60px;
    }
    #contactText>div>p{
        font-size: 16px;
        line-height: 32px;
    }
    #contactText a{
        text-decoration: none;
        color: #000;
        font-size: 16px;
    }

</style>
